var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4285f4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17.925 -17.925)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M29.876,29.876a7,7,0,1,0-9.9,0A7.005,7.005,0,0,0,29.876,29.876Zm-9.4-9.4a6.306,6.306,0,1,1,0,8.918A6.333,6.333,0,0,1,20.477,20.477Zm1.836,4.459a.345.345,0,0,1,.35-.35h1.923V22.663a.35.35,0,1,1,.7,0v1.923h1.923a.345.345,0,0,1,.35.35.376.376,0,0,1-.35.35H25.286v1.923a.376.376,0,0,1-.35.35.345.345,0,0,1-.35-.35V25.286H22.663A.345.345,0,0,1,22.313,24.936Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/add_circle.33728d1b337e9dc8aa6bd4a9662a52c2.svg";
export { ForwardRef as ReactComponent };